// ---------------------------------------------
// ---              FE constants             ---
// ---------------------------------------------


// impostazione stile SITO e abilitazione comboBox x cambiarlo
let SITE_STYLE_ACTIVE="C"
const ENABLE_SWITCH_STILE = true;
//const ENABLE_SWITCH_STILE = false;
//const ENABLE_CREATE_ACCOUNT = false;
const ENABLE_CREATE_ACCOUNT = true;

// identificazione cliente
const CUSTOMER = "Abaco srl";
const CUSTOMER_CODE = "0001";
const CUSTOMER_VIA = "via Roma 10";
const CUSTOMER_CITTA = "20121 Milano";
const CUSTOMER_EMAIL = "informazioni@studio-professionale.it";

const STRIPE_PUBLIC_KEY_FE='pk_test_51OUw3IHYUETFznHdNruu2jhgzYf0wwJlSdP62oknyCMooXzDEJKRfXnNvLhJPbeFAScA69UdDvfVA5y0dQtJJ2sD00eh0tlXl0'
//const GOOGLE_MAPS_KEY = "AIzaSyBwKXrra2hrEReDO5UfhALt9xYyj2oKItM";   // prussianimassimo@    from  __/__/__  exp 10/02/2026  90ggFree
const GOOGLE_MAPS_KEY = "AIzaSyBxmUdg-2bxMsmccdWM1s8whS077ZF35HI";     // massimo.prussiani@   from 23/02/96    90ggFree

// Breadcrumbs user pages 
const BC_HOME = "HOME";
const BC_SERVIZI = "Servizi";
const BC_EVENTI = "Partner";
const BC_PRODOTTI = "Prodotti";
const BC_STAFF = "Staff";
const BC_AREACOMPETENZA = "AreaCompetenza";
const BC_CHISIAMO = "ChiSiamo";
const BC_DOVESIAMO = "DoveSiamo";
const BC_CONTATTI = "Contatti";
const BC_LOGIN = "Login";
const BC_CREAACCOUNT = "CreaAccount";
const BC_CARRELLO = "Carrello";
const BC_CHECKOUT = "Checkout";
const BC_BRANDS = "Brand";
const BC_COUPONS = "Coupon";
const BC_GIFTCARDS = "GiftCard";

// Breadcrumbs admin pages 
const BC_ADMIN = "ADMIN";
const BC_ADMIN_CATEGORIES = "Tipi prodotti";
const BC_ADMIN_CATEGORIES_CREATE = "Crea tipo prodotto";
const BC_ADMIN_CATEGORIES_EDIT = "Modifica tipo prodotto";
const BC_ADMIN_TYPES = "Tipi servizi";
const BC_ADMIN_TYPES_CREATE = "Crea tipo servizio";
const BC_ADMIN_TYPES_EDIT = "Modifica tipo servizio";
const BC_ADMIN_EVENTTYPES = "Tipi eventi";
const BC_ADMIN_EVENTTYPES_CREATE = "Crea tipo evento";
const BC_ADMIN_EVENTTYPES_EDIT = "Modifica tipo evento";
const BC_ADMIN_PRODUCTS = "Prodotti";
const BC_ADMIN_PRODUCTS_CREATE = "Crea prodotto";
const BC_ADMIN_PRODUCTS_EDIT = "Modifica prodotto";
const BC_ADMIN_EVENTS = "Eventi";
const BC_ADMIN_EVENTS_CREATE = "Crea evento";
const BC_ADMIN_EVENTS_EDIT = "Modifica evento";
const BC_ADMIN_SERVICES = "Servizi";
const BC_ADMIN_SERVICES_CREATE = "Crea servizio";
const BC_ADMIN_SERVICES_EDIT = "Modifica servizio";
const BC_ADMIN_MESSAGES = "Messaggi";
const BC_ADMIN_MESSAGES_VIEW = "Dettagli messaggio";
const BC_ADMIN_CUSTOMERS = "Clienti";
const BC_ADMIN_CUSTOMERS_CREATE = "Crea cliente";
const BC_ADMIN_CUSTOMERS_EDIT = "Modifica cliente";
const BC_ADMIN_USERS = "Utenti";
const BC_ADMIN_USERS_CREATE = "Crea utente";
const BC_ADMIN_USERS_EDIT = "Modifica utente";
const BC_ADMIN_ANALISYS = "Analisi";
const BC_ADMIN_CONFIGS = "Configura";
const BC_ADMIN_CHAT = "Chat";
const BC_ADMIN_PAYMENTS = "Pagamenti";
const BC_ADMIN_PAYMENTS_VIEW = "Vedi pagamento";
const BC_ADMIN_ORDERS = "Ordini";
const BC_ADMIN_ORDERS_VIEW = "Dettagli ordine";
const BC_USER_ORDERS = "i miei ordini";
const BC_USER_ORDERS_VIEW = "Dettagli ordine";

// const COLOR_BACKGROUND_MENU1_STYLE_A = "#0D6EFD"   // è il primary 
const COLOR_TEXT_FOOTER_STYLE_A_MYSTUDIO = "#0000008C"    // non fnz nel file css    
const COLOR_BACKGROUND_MENU1_STYLE_A_MYSTUDIO = "#222f7f"   // è il primary 
const COLOR_BACKGROUND_MENU2_STYLE_A_MYSTUDIO = "#e9e9e9"    // è il grigio chiaro adatto al menu2

const COLOR_TEXT_FOOTER_STYLE_A_MYSHOP = "#e9e9e9"    // non fnz nel file css    
const COLOR_BACKGROUND_MENU1_STYLE_A_MYSHOP = "#222f7f"   // è il primary 
const COLOR_BACKGROUND_MENU2_STYLE_A_MYSHOP = "#e9e9e9"    // è il grigio chiaro adatto al menu2


const COLOR_TEXT_FOOTER_STYLE_B = "#0000008C"    // non fnz nel file css    (last version)
const COLOR_BACKGROUND_MENU1_STYLE_B = "#222f7f" // è il blu fb
const COLOR_BACKGROUND_MENU2_STYLE_B = "#e9e9e9" // è il grigio chiaro   

const COLOR_TEXT_FOOTER_STYLE_C = "#F8F9FA"    // non fnz nel file css
const COLOR_BACKGROUND_MENU1_STYLE_C = "#222f7f"
const COLOR_BACKGROUND_MENU2_STYLE_C = "#222f7f"

const COLOR_TEXT_FOOTER_STYLE_D = "#F8F9FA"    // non fnz nel file css
const COLOR_BACKGROUND_MENU1_STYLE_D = "#222f7f"
const COLOR_BACKGROUND_MENU2_STYLE_D = "#222f7f"

const CUSTOMER_SLIDE_URL_ARRAY = [
  "https://www.shoppingclick.it/myplanner/storage-images/customer-0001/categorie/categoria-abbigliamentodonna.jpg",
  "https://www.shoppingclick.it/myplanner/storage-images/customer-0001/categorie/categoria-accessoridonna.jpg",
  "https://www.shoppingclick.it/myplanner/storage-images/customer-0001/categorie/categoria-attrezzigiardino.jpg",
  "https://www.shoppingclick.it/myplanner/storage-images/customer-0001/categorie/categoria-computers.jpg",
  "https://www.shoppingclick.it/myplanner/storage-images/customer-0001/categorie/categoria-games.jpg",
  "https://www.shoppingclick.it/myplanner/storage-images/customer-0001/categorie/categoria-lavatrici.jpg",
  "https://www.shoppingclick.it/myplanner/storage-images/customer-0001/categorie/categoria-trapani.jpg",
  "https://www.shoppingclick.it/myplanner/storage-images/customer-0001/categorie/categoria-tablets.jpg",
];

const PAGE_COUPON_TITOLO = "seguiamo Clienti ed Iniziative di rilievo nazionale"
const PAGE_COUPON_TESTO = "Il nostro Studio ritiene che la professione debba essere sempre e costantemente al passo con le nuove tecnologie.  \
Crediamo nella costante crescita delle Professionalità. Riteniamo fondamentale il continuo aggiornamento dei nostri Professionisti. \
Le conoscenze offerte dal nostro team non sono seconde a nessuno. Il nostro team di ricerca e sviluppo lavora costantemente per rilevare le novità e le migliori soluzioni.";
const PAGE_COUPON_SLIDE_1_URL = "https://www.shoppingclick.it/myplanner/storage-images/customer-"+CUSTOMER_CODE+"/slides/slide4.jpg";
const PAGE_COUPON_SLIDE_1_TITOLO = "vantiamo Clienti di spicco";
const PAGE_COUPON_SLIDE_1_SOTTOTITOLO = "per garantirti la massima professionalità";
const PAGE_COUPON_SLIDE_2_URL = "https://www.shoppingclick.it/myplanner/storage-images/customer-"+CUSTOMER_CODE+"/slides/slide5.jpg";
const PAGE_COUPON_SLIDE_2_TITOLO = "vantiamo Clienti di spicco";
const PAGE_COUPON_SLIDE_2_SOTTOTITOLO = "per garantirti la massima professionalità";
const PAGE_COUPON_SLIDE_3_URL = "https://www.shoppingclick.it/myplanner/storage-images/customer-"+CUSTOMER_CODE+"/slides/slide6.jpg";
const PAGE_COUPON_SLIDE_3_TITOLO = "vantiamo Clienti di spicco";
const PAGE_COUPON_SLIDE_3_SOTTOTITOLO = "per garantirti la massima professionalità";
                
const PAGE_GIFTCARD_TITOLO = "Seguici"
const PAGE_GIFTCARD_TESTO = "Seguiamo costantemente Convegni del settore perchè conosciamo l'importanza dei continui aggiornamenti professionali. \
Crediamo nella costante crescita delle Professionalità. Riteniamo fondamentale il continuo aggiornamento dei nostri Professionisti. \
Abbiamo a cuore le tue problematiche e garantiamo la migliore soluzione possibile.";
const PAGE_GIFTCARD_SLIDE_1_URL = "https://www.shoppingclick.it/myplanner/storage-images/customer-"+CUSTOMER_CODE+"/slides/slide61.jpg";
const PAGE_GIFTCARD_SLIDE_1_TITOLO = "Pubblicazioni per lasciare il segno della nostra professionalità";
const PAGE_GIFTCARD_SLIDE_1_SOTTOTITOLO = "Eveti per condividere informazioni e metodologie";
const PAGE_GIFTCARD_SLIDE_2_URL = "https://www.shoppingclick.it/myplanner/storage-images/customer-"+CUSTOMER_CODE+"/slides/slide62.jpg";
const PAGE_GIFTCARD_SLIDE_2_TITOLO = "Pubblicazioni per lasciare il segno della nostra professionalità";
const PAGE_GIFTCARD_SLIDE_2_SOTTOTITOLO = "Eveti per condividere informazioni e metodologie";
const PAGE_GIFTCARD_SLIDE_3_URL = "https://www.shoppingclick.it/myplanner/storage-images/customer-"+CUSTOMER_CODE+"/slides/slide63.jpg";
const PAGE_GIFTCARD_SLIDE_3_TITOLO = "Pubblicazioni per lasciare il segno della nostra professionalità";
const PAGE_GIFTCARD_SLIDE_3_SOTTOTITOLO = "Eveti per condividere informazioni e metodologie";
                
const PAGE_NEWS_TITOLO = "Seguici"
const PAGE_NEWS_TESTO = "Instauriamo con i nostri clienti una profiqua comunicazione su tutto ciò che può interessare la miglior soluzione praticabile. \
Crediamo nel continuo esame delle problematiche al fine di rettificare quanto inerente le esigenze dei Clienti. Riteniamo fondamentale il continuo aggiornamento dei nostri Professionisti. \
Abbiamo a cuore le tue problematiche e garantiamo la migliore soluzione possibile.";
const PAGE_NEWS_SLIDE_1_URL = "https://www.shoppingclick.it/myplanner/storage-images/customer-"+CUSTOMER_CODE+"/slides/slide64.jpg";
const PAGE_NEWS_SLIDE_1_TITOLO = "condividiamo conoscenze e modi di pensare";
const PAGE_NEWS_SLIDE_1_SOTTOTITOLO = "pubblichiamo approfondimenti";
const PAGE_NEWS_SLIDE_2_URL = "https://www.shoppingclick.it/myplanner/storage-images/customer-"+CUSTOMER_CODE+"/slides/slide65.jpg";
const PAGE_NEWS_SLIDE_2_TITOLO = "condividiamo conoscenze e modi di pensare";
const PAGE_NEWS_SLIDE_2_SOTTOTITOLO = "pubblichiamo approfondimenti";
const PAGE_NEWS_SLIDE_3_URL = "https://www.shoppingclick.it/myplanner/storage-images/customer-"+CUSTOMER_CODE+"/slides/slide66.jpg";
const PAGE_NEWS_SLIDE_3_TITOLO = "condividiamo conoscenze e modi di pensare";
const PAGE_NEWS_SLIDE_3_SOTTOTITOLO = "pubblichiamo approfondimenti";

// prelievo IMMAGINI CLIENTE da www.shoppingclick.it (non utilizzato)
// =>/home/shouser10/htdocs/www.shoppingclick.it/myplanner/storage-images/site-myplanneronline-it
const URL_IMAGES_CUSTOMER = "https://www.shoppingclick.it/mystudio/storage-images/customer-"+CUSTOMER_CODE+"/";
const URL_IMAGES_CUSTOMER1 = "/images-"+CUSTOMER_CODE+"/";

module.exports = { 
  ENABLE_SWITCH_STILE,
  ENABLE_CREATE_ACCOUNT,
  SITE_STYLE_ACTIVE,
  CUSTOMER,
  CUSTOMER_CODE,
  CUSTOMER_VIA,
  CUSTOMER_CITTA,
  CUSTOMER_EMAIL,
  STRIPE_PUBLIC_KEY_FE,
  GOOGLE_MAPS_KEY,
  CUSTOMER_SLIDE_URL_ARRAY,

  BC_HOME,
  BC_SERVIZI,
  BC_EVENTI,
  BC_PRODOTTI,
  BC_STAFF,
  BC_AREACOMPETENZA,
  BC_CHISIAMO,
  BC_DOVESIAMO,
  BC_CONTATTI,
  BC_LOGIN,
  BC_CREAACCOUNT,
  BC_CARRELLO,
  BC_CHECKOUT,
  BC_BRANDS,
  BC_COUPONS,
  BC_GIFTCARDS,
  BC_ADMIN,
  BC_ADMIN_CATEGORIES,
  BC_ADMIN_CATEGORIES_CREATE,
  BC_ADMIN_CATEGORIES_EDIT,
  BC_ADMIN_TYPES,
  BC_ADMIN_TYPES_CREATE,
  BC_ADMIN_TYPES_EDIT,
  BC_ADMIN_EVENTTYPES,
  BC_ADMIN_EVENTTYPES_CREATE,
  BC_ADMIN_EVENTTYPES_EDIT,
  BC_ADMIN_PRODUCTS,
  BC_ADMIN_PRODUCTS_CREATE,
  BC_ADMIN_PRODUCTS_EDIT,
  BC_ADMIN_EVENTS,
  BC_ADMIN_EVENTS_CREATE,
  BC_ADMIN_EVENTS_EDIT,
  BC_ADMIN_SERVICES,
  BC_ADMIN_SERVICES_CREATE,
  BC_ADMIN_SERVICES_EDIT,
  BC_ADMIN_MESSAGES,
  BC_ADMIN_MESSAGES_VIEW,
  BC_ADMIN_CUSTOMERS,
  BC_ADMIN_CUSTOMERS_CREATE,
  BC_ADMIN_CUSTOMERS_EDIT,
  BC_ADMIN_USERS,
  BC_ADMIN_USERS_CREATE,
  BC_ADMIN_USERS_EDIT,
  BC_ADMIN_ANALISYS,
  BC_ADMIN_CONFIGS,
  BC_ADMIN_CHAT,
  BC_ADMIN_PAYMENTS,
  BC_ADMIN_PAYMENTS_VIEW,
  BC_ADMIN_ORDERS,
  BC_ADMIN_ORDERS_VIEW,
  BC_USER_ORDERS,
  BC_USER_ORDERS_VIEW,

  COLOR_TEXT_FOOTER_STYLE_A_MYSTUDIO,
  COLOR_BACKGROUND_MENU1_STYLE_A_MYSTUDIO,
  COLOR_BACKGROUND_MENU2_STYLE_A_MYSTUDIO,
  COLOR_TEXT_FOOTER_STYLE_A_MYSHOP,
  COLOR_BACKGROUND_MENU1_STYLE_A_MYSHOP,
  COLOR_BACKGROUND_MENU2_STYLE_A_MYSHOP,
  COLOR_TEXT_FOOTER_STYLE_B,
  COLOR_BACKGROUND_MENU1_STYLE_B,
  COLOR_BACKGROUND_MENU2_STYLE_B,
  COLOR_TEXT_FOOTER_STYLE_C,
  COLOR_BACKGROUND_MENU1_STYLE_C,
  COLOR_BACKGROUND_MENU2_STYLE_C,
  COLOR_TEXT_FOOTER_STYLE_D,
  COLOR_BACKGROUND_MENU1_STYLE_D,
  COLOR_BACKGROUND_MENU2_STYLE_D,

  PAGE_COUPON_TITOLO,
  PAGE_COUPON_TESTO,
  PAGE_COUPON_SLIDE_1_URL,
  PAGE_COUPON_SLIDE_1_TITOLO,
  PAGE_COUPON_SLIDE_1_SOTTOTITOLO,
  PAGE_COUPON_SLIDE_2_URL,
  PAGE_COUPON_SLIDE_2_TITOLO,
  PAGE_COUPON_SLIDE_2_SOTTOTITOLO,
  PAGE_COUPON_SLIDE_3_URL,
  PAGE_COUPON_SLIDE_3_TITOLO,
  PAGE_COUPON_SLIDE_3_SOTTOTITOLO,

  PAGE_GIFTCARD_TITOLO,
  PAGE_GIFTCARD_TESTO,
  PAGE_GIFTCARD_SLIDE_1_URL,
  PAGE_GIFTCARD_SLIDE_1_TITOLO,
  PAGE_GIFTCARD_SLIDE_1_SOTTOTITOLO,
  PAGE_GIFTCARD_SLIDE_2_URL,
  PAGE_GIFTCARD_SLIDE_2_TITOLO,
  PAGE_GIFTCARD_SLIDE_2_SOTTOTITOLO,
  PAGE_GIFTCARD_SLIDE_3_URL,
  PAGE_GIFTCARD_SLIDE_3_TITOLO,
  PAGE_GIFTCARD_SLIDE_3_SOTTOTITOLO,
   
  PAGE_NEWS_TITOLO,
  PAGE_NEWS_TESTO,
  PAGE_NEWS_SLIDE_1_URL,
  PAGE_NEWS_SLIDE_1_TITOLO,
  PAGE_NEWS_SLIDE_1_SOTTOTITOLO,
  PAGE_NEWS_SLIDE_2_URL,
  PAGE_NEWS_SLIDE_2_TITOLO,
  PAGE_NEWS_SLIDE_2_SOTTOTITOLO,
  PAGE_NEWS_SLIDE_3_URL,
  PAGE_NEWS_SLIDE_3_TITOLO,
  PAGE_NEWS_SLIDE_3_SOTTOTITOLO,
  
  URL_IMAGES_CUSTOMER,
  URL_IMAGES_CUSTOMER1,
};
